import { Card, CardBody, CardTitle, PopoverBody, PopoverHeader, UncontrolledPopover } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { withNamespaces } from "react-i18next";

const ForestChangeChart = ({ t, geoData }) => {
    const {
        raw_response
    } = geoData || {};

    const series = [
        {
            name: t('Natural Forest'),
            data: [raw_response?.properties?.deforestation_area_ha_natural]
        },
        {
            name: t('Planted Forest'),
            data: [raw_response?.properties?.deforestation_area_ha_planted]
        },
        {
            name: t('Shrubs'),
            data: [raw_response?.properties?.deforestation_area_ha_shrubs]
        }
    ];

    const options = {
        chart: {
            type: "bar",
            stacked: true,
            stackType: "100%"
        },
        plotOptions: {
            bar: {
                horizontal: false
            }
        },
        colors: ["#6aa84f", "#a0a0a0", "#f9d57c"],
        xaxis: {
            categories: [t("Deforestation Area (ha)")], // single category
        },
        legend: {
            position: "bottom",
            horizontalAlign: "center"
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val.toFixed(2) + " %";
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val.toFixed(2) + " ha";
                }
            }
        },
    };

    return (
        <Card>
            <CardBody>
                <CardTitle tag="h5" className="mb-3">
                    <span className="me-1">
                        {t('Forest Disturbance and Deforestation')}
                    </span>

                    <i
                        className="ri-information-line"
                        style={{
                            cursor: 'pointer'
                        }}
                        id="forest-deforestation-help-text"
                    />

                    <UncontrolledPopover
                        trigger="hover"
                        target="forest-deforestation-help-text"
                    >
                        <PopoverHeader>
                            {t('Forest Disturbance and Deforestation')}
                        </PopoverHeader>
                        <PopoverBody>
                            <p>
                                {t('Shows the extent of forest loss or disturbance within the parcel, broken down by land cover type')}:
                            </p>
                            <ul>
                                <li>
                                    <strong>
                                        {t('Natural Forest')}–
                                    </strong>
                                    {t('Loss or degradation of natural forest areas.')}
                                </li>
                                <li>
                                    <strong>
                                        {t('Planted Forest')}–
                                    </strong>
                                    {t('Loss or disturbance in plantations.')}
                                </li>
                                <li>
                                    <strong>
                                        {t('Shrubs')}–
                                    </strong>
                                    {t('Changes in shrub-covered areas.')}
                                </li>
                            </ul>
                            <p>
                                {t('This chart helps quickly identify which land types are most affected and assess deforestation risk under EUDR compliance.')}
                            </p>
                        </PopoverBody>
                    </UncontrolledPopover>
                </CardTitle>
                <ReactApexChart 
                    options={options} 
                    series={series} 
                    type="bar" 
                    height={350} 
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    ForestChangeChart
);
